module.exports = __webpack_public_path__ + "img/oci-black.f960feb5.svg";